(function () {
  const TARGET_SELECTOR = '[data-forms-id="forms-root-823489"] shopify-forms-embed';
  const STYLE_ID = 'custom-shadow-styles-823489';

  const customCSS = `
.form-wrapper {
  margin: 0;
}

form {
  gap: 1.25rem !important;
}

input[type="text"],
input[type="tel"],
textarea,
button[aria-controls="country-selector-dropdown"],
button[aria-controls="custom#industry-selector-dropdown"],
button[aria-controls="custom#business_type-selector-dropdown"] {
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(230, 230, 230, 0.06) 100%) !important;
  color: #C7C7C7 !important;
}

input[type="text"],
input[type="tel"],
textarea {
  &+label {
    color: #C7C7C7;
  }
}

button[aria-controls="country-selector-dropdown"],
button[aria-controls="custom#industry-selector-dropdown"],
button[aria-controls="custom#business_type-selector-dropdown"] {
  max-height: 51px;

  svg path {
    fill: #C7C7C7;
  }
}

[class*="formDisclaimer"] {
  font-size: 0.8125rem !important;
  font-weight: 300 !important;
  line-height: 150% !important;
}

button[class*="formSubmitButton"] {
  width: auto !important;
  min-width: 0 !important;
  padding: 16px 32px !important;
  gap: 8px !important;
  border-radius: 100px !important;
  background: rgba(208, 208, 208, 0.50) !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 150% !important;
}
  `;

  function injectStyles(hostElement) {
    if (!hostElement || !hostElement.shadowRoot) return;

    if (hostElement.shadowRoot.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = customCSS;
    hostElement.shadowRoot.appendChild(style);
  }

  function init() {
    const existingElement = document.querySelector(TARGET_SELECTOR);
    if (existingElement) {
      injectStyles(existingElement);
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          const found = document.querySelector(TARGET_SELECTOR);
          if (found) {
            injectStyles(found);
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();